export const DATES_SET = 'DATES_SET';
export const HOTEL_SELECTED = 'HOTEL_SELECTED';
export const DEFAULT_RESOURCE_ORDER_SET = 'DEFAULT_RESOURCE_ORDER_SET';

export const ROOM_SELECTED = 'ROOM_SELECTED';

// dates view actions
export const CITY_SELECTED = 'CITY_SELECTED';
export const START_DATE_SET = 'START_DATE_SET';
export const END_DATE_SET = 'END_DATE_SET';
export const VOUCHER_CODE_SET = 'VOUCHER_CODE_SET';
export const START_TIME_UTC_SET = 'START_TIME_UTC_SET';
export const END_TIME_UTC_SET = 'END_TIME_UTC_SET';
export const CLEAR_TIMES = 'CLEAR_TIMES';

export const AGE_CATEGORY_OCCUPANCY_SET = 'AGE_CATEGORY_OCCUPANCY_SET';

// rates view actions
export const SPACE_TYPE_COUNT_SET = 'SPACE_TYPE_COUNT_SET';
export const SPACE_TYPE_COUNT_CHANGED = 'SPACE_TYPE_COUNT_CHANGED';
export const SPACE_TYPE_COUNT_RESET = 'SPACE_TYPE_COUNT_RESET';
export const ROOM_OCCUPANCY_CHANGED = 'ROOM_OCCUPANCY_CHANGED';

export const PRODUCT_ADDED = 'PRODUCT_ADDED';
export const PRODUCT_REMOVED = 'PRODUCT_REMOVED';
export const PROMOTED_SERVICE_ADDED = 'PROMOTED_SERVICE_ADDED';
export const PROMOTED_SERVICE_REMOVED = 'PROMOTED_SERVICE_REMOVED';
export const RESOURCE_ORDER_ADDED = 'RESOURCE_ORDER_ADDED';
